
import React from "react";
import { Link } from "react-router-dom";
import { ClockIcon } from "@heroicons/react/24/outline";

const getUserPermissions = () => {
  try {
    return JSON.parse(localStorage.getItem("permissions") || "[]").map(
      (permission) => permission.permissionSlug
    );
  } catch (error) {
    return [];
  }
};

export const canViewAuditHistory = () =>
  localStorage.getItem("userId") == 1 ||
  getUserPermissions().includes("AUDIT_LOG_SHOW");

const AuditHistoryButton = ({ module, entityType, entityId }) => {
  if (!canViewAuditHistory() || entityId === null || entityId === undefined) {
    return null;
  }

  const query = new URLSearchParams({
    module,
    entityType,
    entityId: String(entityId),
  }).toString();

  return (
    <Link
      to={`/admin/audit-logs?${query}`}
      title="Xem lịch sử thao tác"
      aria-label="Xem lịch sử thao tác"
      className="btn btn-outline btn-info btn-sm my-1 rounded px-3"
    >
      <ClockIcon className="h-5 w-5" />
    </Link>
  );
};

export default AuditHistoryButton;


